import NewsDetailsSection from "../components/newsDetailsSection/NewsDetailsSection";

function NewsDetails() {
  return <NewsDetailsSection />;
}

export default NewsDetails;
